import { render, staticRenderFns } from "./GridComponentAdapterSitecore.vue?vue&type=template&id=513f28cd"
import script from "./GridComponentAdapterSitecore.vue?vue&type=script&lang=js"
export * from "./GridComponentAdapterSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports